module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"SortBy":"Sort By","Add":"Add","ColumnSettings":"Column Settings","cancel":"Cancel","Apply":"Apply"},"zh":{"SortBy":"排序","Add":"添加","ColumnSettings":"列设置","cancel":"取消","Apply":"应用"},"mm":{"SortBy":"အစီအစဉ်အတိုင်း စီပါ","Add":"ထည့်မည်","ColumnSettings":"ကော်လံဆက်တင်များ","cancel":"ပယ်ဖျက်","Apply":"လျှောက်ထားပါ"}}')
  delete Component.options._Ctor
}
